import asyncComponent from '../util/async-component';

export const AsyncApplicationPage = asyncComponent(() => import('./application-page'));
